import { createSelector } from 'reselect';
import { basicSelector } from './helpers';
import { getIsEditingGridLayouts } from './moduleSelectors';
import { getHasAiLayoutSkillAccess } from './authSelectors';
import { getIsLandingOrSitePage } from './contentReadOnlyDataSelectors';
export const getGridLayoutGeneration = basicSelector(state => state.gridsLayoutGeneration);
export const getIsGridLayoutGenerationAvailable = createSelector([getHasAiLayoutSkillAccess, getIsEditingGridLayouts, getIsLandingOrSitePage], (hasAiLayoutSkillAccess, isEditingGridLayouts, isLandingOrSitePage) =>
// Explicitly checking for site / landing pages since the relevant reducer is only included in PEUI
isLandingOrSitePage && hasAiLayoutSkillAccess && isEditingGridLayouts);
export const getIsGridLayoutGenerationTaskRunning = createSelector([getIsGridLayoutGenerationAvailable, getGridLayoutGeneration], (isGridLayoutGenerationAvailable, gridsLayoutGeneration) => {
  if (!isGridLayoutGenerationAvailable || !gridsLayoutGeneration) {
    return false;
  }
  return gridsLayoutGeneration.isTaskRunning;
});
export const getGridLayoutIdGeneratingLayout = createSelector([getIsGridLayoutGenerationTaskRunning, getGridLayoutGeneration], (isTaskRunning, gridsLayoutGeneration) =>
// isTaskRunning will return false if gridLayoutGeneration is undefined
isTaskRunning ? gridsLayoutGeneration.gridLayoutId : undefined);
export const getGridLayoutGenerationInitiatingNode = createSelector([getIsGridLayoutGenerationTaskRunning, getGridLayoutGeneration], (isTaskRunning, gridsLayoutGeneration) =>
// isTaskRunning will return false if gridLayoutGeneration is undefined
isTaskRunning ? gridsLayoutGeneration.initiatingNode : undefined);